// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTrophyAssignBody = {
  poolId: string;
  seasonId: string;
  targetUserIds: string[];
};

export type typeTrophyAssignOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { awardGroupId: string; trophyAssignmentIds: string[] };
};

export type typeTrophyAssignOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTrophyAssignOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTrophyAssignOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTrophyAssignBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["poolId", "seasonId", "targetUserIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTrophyAssign(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTrophyAssignBody);
  }

  return async function postTrophyAssign(
    payload: typeTrophyAssignBody,
  ): Promise<typeTrophyAssignOutput200 | typeTrophyAssignOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTrophyAssign" failed before calling the network. #6d22125dead8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6d22125dead8" },
        },
        data: null,
      } as typeTrophyAssignOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/trophy/assign`,
      httpMethod: "POST",
      options,
    })) as typeTrophyAssignOutput200 | typeTrophyAssignOutput400;
  };
}
